var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpeaker = function SvgSpeaker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#speaker_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.383.076A1 1 0 0 1 16 1v14a1 1 0 0 1-1.707.707l-2.071-2.071a9 9 0 0 0-2.88-1.934l.555 1.665A2 2 0 0 1 8 16H6a2 2 0 0 1-1.897-1.367l-1-3A2 2 0 0 1 3 11a3 3 0 0 1 0-6h2.858a9 9 0 0 0 6.364-2.636l2.07-2.071a1 1 0 0 1 1.09-.217M7 9V6.94Q6.433 7 5.858 7H3a1 1 0 1 0 0 2zm-2 2 1 3h2l-.975-2.924A9 9 0 0 0 5.862 11zm9-7.586-.364.364A11 11 0 0 1 9 6.542v2.916a11 11 0 0 1 4.636 2.764l.364.364z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "speaker_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgSpeaker;